import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import LdsVideoPlayer from "../../components/LdsVideoPlayer";
import LdsFigureCaption from "../../components/LdsFigureCaption";
import LdsKalturaPlayer from "../../components/LdsVideoPlayer/KalturaPlayer";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.2 Demonstration Case 2: Positive
            </h1>
            <p className="me-4">Estimated time to complete: 3 minutes</p>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <LdsFigureCaption
                textContent={
                  <>
                    <p>
                      <strong>AUDIO</strong>
                      <br />
                      VO: (FEMALE)
                      <br />
                    </p>
                    <p>
                      This is Demonstration Case Number 2. This is a positive
                      case. The size and contrast have already been adjusted.
                    </p>
                    <p>
                      Starting in the cerebellum, we identify intense activity
                      within the white matter of the cerebellum, surrounded by
                      less intense activity in the gray matter. The cerebellum
                      can also be identified on the coronal images, seen here.
                      Again, white matter activity is seen here with intense
                      uptake, surrounded by less intense activity in the gray
                      matter.
                    </p>
                    <p>
                      Returning to the transverse images and moving superiorly,
                      we can identify the temporal lobes, seen here, and the
                      occipital lobes, seen posteriorly. In contrast to
                      Demonstration Case Number 1, white matter tracts are not
                      readily identifiable. Intense activity is seen extending
                      to the periphery in the temporal lobes on the left, as
                      well as in the occipital lobes. This pattern is also seen
                      on the right-hand side. Therefore, there is loss of
                      gray-white contrast in the temporal and occipital regions.
                    </p>
                    <p>
                      As we move superiorly and enter into the frontal cortices,
                      again, there is loss of gray-white contrast. In comparison
                      to Demonstration Case Number 1, finger-like projections of
                      intense white matter activity cannot be differentiated
                      from less intense gray matter uptake. This pattern can be
                      seen on both the right and the left side. Again, there is
                      loss of gray-white contrast in the frontal cortices.
                      Moving superiorly, you may identify white matter tracts
                      extending from the anterior to the posterior aspect of the
                      brain. However, there remains relative loss of gray-white
                      contrast, even in the parietal region.
                    </p>
                    <p>
                      As we move more superiorly, this pattern continues, and
                      there is loss of gray-white contrast in multiple locations
                      within the parietal lobe.
                    </p>
                    <p>
                      Near the top of the brain, you can identify the medial
                      parietal region. This region shows loss of gray-white
                      contrast, as there is increased activity in the gray
                      matter of the medial parietal region. This area is also
                      known as the precuneus. The coronal images may also
                      identify abnormal areas of gray-white contrast. In this
                      particular slice, increased activity is seen extending to
                      the periphery on the left and the right.
                    </p>
                    <p>
                      When there is loss of gray-white contrast in two or more
                      regions, a scan is positive. Please remember that right
                      and left lobes (for example, right and left frontal lobes)
                      only count as one region. In Demonstration Case Number 2,
                      the temporal lobes, occipital lobes, parietal lobes,
                      including the precuneus, and frontal lobes show reduced
                      gray-white contrast. Therefore, this scan is positive.
                    </p>
                  </>
                }
                buttonIcon="MinusCircle"
                buttonTextAlign="left"
                showDescriptionText="Video Transcript"
                hideDescriptionText="Video Transcript"
                radiusSize="small"
              >
                <LdsVideoPlayer brandBorder={false}>
                  <LdsKalturaPlayer
                    videoId="1_a8upieh2"
                    partnerId="1759891"
                    uiConfId="54959122"
                    nextUrl="/module-2/module-2-3-3"
                  />
                </LdsVideoPlayer>
              </LdsFigureCaption>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              id="next"
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              disabled={true}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
